import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import configureStore from './stores';
import App from './components/App';
import modal from './components/Modal';
// import modal from './components/Alert';
import lmsRender from './components/Render';
import { EventEmitter } from 'fbemitter';
import {
    updateCommonData,
    INITIAL_SET_DATA,
    SET_DATA,
    SET_MODE,
    RELOAD_ENTRY,
} from './actions';
import { ModalTypes, ThemeTypes } from './Constants';

if (!window._babelPolyfill) {
    require('babel-polyfill');
}
const store = configureStore();
let _isInitialize = false;
let _container = null;
let element = null;
// 데이터 형식에 따라 변경될 여지가 있음.
export function init({ mode, target, data = {}, theme }) {
    _isInitialize = true;
    _container = target;
    if (typeof target === 'string') {
        _container = document.getElementById(target);
    }

    store.dispatch(
        updateCommonData(INITIAL_SET_DATA, {
            mode,
            data,
            theme,
        })
    );
    element = (
        <Provider store={store}>
            <App mode={mode} />
        </Provider>
    );
    render(element, _container);

    if (module.hot) {
        module.hot.accept('./components/App', () => {
            const NextApp = require('./components/App').default; // eslint-disable-line global-require
            render(element, _container);
        });
    }
}

const emitter = new EventEmitter();
export function on(eventType, callback) {
    emitter.addListener(eventType, callback);
}

export function one(eventType, callback) {
    emitter.once(eventType, callback);
}

export function off(eventType) {
    emitter.removeAllListeners(eventType);
}

export function emit(eventType, ...args) {
    emitter.emit(eventType, ...args);
}

const _title = {
    get alert_title() {
        const { General = {} } = Lang;
        const { alert_title = '알림' } = General;
        return alert_title;
    },
    get confirm_title() {
        const { General = {} } = Lang;
        const { confirm_title = '확인' } = General;
        return confirm_title;
    },
};

export const Modal = modal;

const textareaModal = new modal(
    {
        title: _title.alert_title,
        type: ModalTypes.TEXTAREA,
        theme: ThemeTypes.BLUE,
    },
    { isCommon: true }
);
//function _alert(content){
function _textarea(content, title, options) {
    textareaModal.modalData = Object.assign({}, textareaModal.modalData[0], {
        content,
        options,
        title: title || _title.alert_title,
    });
    textareaModal.show();
    textareaModal.on('hide', () => {
        textareaModal.off('hide');
    });
    return textareaModal;
}
export const alertTextarea = _textarea;

const alertModal = new modal(
    {
        title: _title.alert_title,
        type: ModalTypes.ALERT,
        theme: ThemeTypes.BLUE,
    },
    { isCommon: true }
);
//function _alert(content){
function _alert(content, title, options) {
    if (typeof content === 'string') {
        content = content.replace(/<br>/g, '\n');
    }
    alertModal.modalData = Object.assign({}, alertModal.modalData[0], {
        content,
        options,
        theme:
            options && options.THEME
                ? ThemeTypes[`${options.THEME}`]
                : ThemeTypes.BLUE,
        title: title || _title.alert_title,
    });
    alertModal.show();
    alertModal.on('hide', () => {
        alertModal.off('hide');
    });
    return alertModal;
}
export const alert = _alert;

const confirmModal = new modal(
    {
        title: _title.confirm_title,
        type: ModalTypes.CONFIRM,
        theme: ThemeTypes.BLUE,
    },
    { isCommon: true }
);
function _confirm(content, title, options) {
    confirmModal.modalData = Object.assign({}, confirmModal.modalData[0], {
        content,
        options,
        title: title || _title.confirm_title,
    });
    confirmModal.show();
    return new Promise((resolve, reject) => {
        confirmModal.on('click', function (event) {
            let isConfirm = event === 'ok';
            confirmModal.off('click');
            confirmModal.off('hide');
            resolve(isConfirm);
        });
        confirmModal.on('hide', function () {
            confirmModal.off('click');
            confirmModal.off('hide');
            resolve(false);
        });
    });
}
export const confirm = _confirm;

export const setDialogTheme = (themeName) => {
    const theme = ThemeTypes[themeName] || ThemeTypes.BLUE;
    alertModal.modalData[0].theme = theme;
    confirmModal.modalData[0].theme = theme;
    return theme;
};

export const Render = lmsRender;

export function setMode(mode, data) {
    store.dispatch(updateCommonData(INITIAL_SET_DATA, { mode, data }));
}

export function setData(data) {
    store.dispatch(updateCommonData(SET_DATA, data));
}

export function getMode() {
    return store.getState().common.mode;
}

export function getData() {
    return store.getState().common.data;
}

export function reloadEntry() {
    return store.dispatch(updateCommonData(RELOAD_ENTRY, true));
}

export function isInitialize() {
    return _isInitialize;
}

export function getContainer() {
    return _container;
}

export function changeContainer(container) {
    render(element, container);
    return store.dispatch(updateCommonData(RELOAD_ENTRY, true));
}



// WEBPACK FOOTER //
// ./index.js